import { RootWrapper } from 'store/components/RootWrapper'

//
export const wrapRootElement = RootWrapper
